import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Body } from "@vds/typography";
import { AccordionTitle as CoreAccordionTitle } from "@vds-core/accordions";

var AccordionTitle = function AccordionTitle(props) {
  return /*#__PURE__*/React.createElement(CoreAccordionTitle, _extends({}, props, {
    typographyComponent: Body,
    typeSize: "large",
    bold: true
  }));
};

AccordionTitle.displayName = "AccordionTitle";
export default AccordionTitle;